// extracted by css-extract-rspack-plugin
export default {"seo_override":"_9g_T8","seoOverride":"_9g_T8","#":"SbWZ1"};